'use client';

import React from 'react';
import { usePathname } from 'next/navigation';

// Landing pages that bring their own footer
const HIDDEN_PATHS = [
    '/nokhbegan-test/',
    '/nokhbegan-54/',
    '/nokhbegan/',
    '/best-exchange-landing/',
    '/trade-webinar-24/',
];

/** Hides the footer on landing pages; the footer itself stays a server component. */
export default function FooterGate({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    if (HIDDEN_PATHS.includes(pathname) || pathname.startsWith('/profile/dashboard/')) return null;
    return <>{children}</>;
}
